export const ADMIN_EMAILS = [
    "admin@mentaldesire.com",
    "kevalc@eoniansoftware.com",
];
